import { render, staticRenderFns } from "./facebook-photos.vue?vue&type=template&id=b9c55250&scoped=true&"
import script from "./facebook-photos.vue?vue&type=script&lang=js&"
export * from "./facebook-photos.vue?vue&type=script&lang=js&"
import style0 from "./facebook-photos.vue?vue&type=style&index=0&id=b9c55250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c55250",
  null
  
)

export default component.exports